export default "__VITE_ASSET__92c3a6c9__"